module.exports = __webpack_public_path__ + "img/icon-rank-3.a4f3eb42.svg";